// extracted by mini-css-extract-plugin
export default {"flavor_option":"SP","out_of_stock_text":"TP","out_of_stock":"UP","flavor_option_image":"VP","flavor_option_info":"WP","flavor_option_title":"XP","flavor_option_limited":"YP","flavor_option_amount_wrapper":"ZP","flavor_option_amount_button":"aQ","zero_amount":"bQ","no_flavors":"cQ","no_flavors_active":"eQ","flavor_option_select_wrapper":"fQ","flavor_option_select_wrapper__selected":"gQ"};
    if(module.hot) {
      // 1711394579172
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  